const NO_MA = 0;
const UP_PEND = 1;
const ONBOARDED = 2;
const UP_FAIL = 3;
const CR_PEND = 4;
const ONBOARD_FAILED = 5;
const CR_FAIL = 6;
const MA_ACTIVE = 7;
const MA_RELEASED = 10;
// Future needs
const OBSOLETE = 8;
const OUTDATE = 9;
const PARTIAL_SUCCESS = 11;
const MA_DELETE_PENDING = 12;
const MA_DELETE_SUCCESS = 13;
const MA_DELETE_FAILED = 14;
const MA_MAINTENANCE = 15;

export const masterAgreementStatusValues = Object.freeze({
  noMasterAgreement: {
    typeId: NO_MA,
    name: "No Master Agreement has been sent yet",
    nameShort: "MA not sent",
    allowed: {
      onboarding: false,
      releasing: false,
      updating: false,
      creation: true,
      pendingMessage: false,
      poRequest: false,
    },
  },
  masterAgreementActive: {
    typeId: MA_ACTIVE,
    name: "Master Agreement has been accepted",
    nameShort: "MA accepted",
    allowed: {
      onboarding: false,
      releasing: true,
      updating: true,
      creation: false,
      pendingMessage: false,
      poRequest: false,
    },
  },
  masterAgreementReleased: { // Onboarding can occur at this step
    typeId: MA_RELEASED,
    name: "Master Agreement has been Released. Onboarding with ITSM is now being attempted",
    nameShort: "MA released",
    allowed: {
      onboarding: false,
      releasing: false,
      updating: false,
      creation: false,
      pendingMessage: true,
      poRequest: false,
    },
  },
  itsmOnboarded: { // Happy Path end state
    typeId: ONBOARDED,
    name: "The Master Agreement has been released and ITSM has been updated with the contract account. Devices may now be deployed",
    nameShort: "Onboarded",
    allowed: {
      onboarding: false,
      releasing: false,
      updating: true,
      creation: false,
      pendingMessage: false,
      poRequest: true,
    },
  },
  itsmOnboardingFailed: {
    typeId: ONBOARD_FAILED,
    name: "ITSM onboarding has failed. Please take corrective action",
    nameShort: "Onboarding error",
    allowed: {
      onboarding: true,
      releasing: false,
      updating: false,
      creation: false,
      pendingMessage: false,
      poRequest: false,
    },
  },
  createPending: {
    typeId: CR_PEND,
    name: "Master Agreement create pending",
    nameShort: "MA pending",
    allowed: {
      onboarding: false,
      releasing: false,
      updating: false,
      creation: false,
      pendingMessage: true,
      poRequest: false,
    },
  },
  createFailed: {
    typeId: CR_FAIL,
    name: "Master Agreement creation failed. Resend is now allowed",
    nameShort: "MA error",
    allowed: {
      onboarding: false,
      releasing: false,
      updating: false,
      creation: true,
      pendingMessage: false,
      poRequest: false,
    },
  },
  updatePending: {
    typeId: UP_PEND,
    name: "Master Agreement append is pending",
    nameShort: "MA pending",
    allowed: {
      onboarding: false,
      releasing: false,
      updating: false,
      creation: false,
      pendingMessage: true,
      poRequest: false,
    },
  },
  updateFailed: {
    typeId: UP_FAIL,
    name: "Master Agreement append has failed. Resend is now allowed",
    nameShort: "MA error",
    allowed: {
      onboarding: false,
      releasing: false,
      updating: true,
      creation: false,
      pendingMessage: false,
      poRequest: false,
    },
  },
  obsolete: {
    typeId: OBSOLETE,
    name: "Project changes render the Master Agreement no longer valid",
    nameShort: "MA update needed",
    allowed: {
      onboarding: false,
      releasing: false,
      updating: true,
      creation: false,
      pendingMessage: false,
      poRequest: false,
    },
  },
  outdated: {
    typeId: OUTDATE,
    name: "Master Agreement has expired",
    nameShort: "MA update needed",
    allowed: {
      onboarding: false,
      releasing: false,
      updating: true,
      creation: false,
      pendingMessage: false,
      poRequest: false,
    },
  },
  // partial success solutions
  partialSuccess: {
    typeId: PARTIAL_SUCCESS,
    name: "MA is in partially success state. Resend is now allowed.",
    nameShort: "MA error",
    allowed: {
      onboarding: false,
      releasing: false,
      updating: false,
      creation: true,
      pendingMessage: false,
      poRequest: false,
    },
  },
  deletePending: {
    typeId: MA_DELETE_PENDING,
    name: 'Master Agreement delete is pending in ITSM',
    nameShort: "MA Delete pending",
    allowed: {
      onboarding: false,
      releasing: false,
      updating: false,
      creation: true,
      pendingMessage: false,
      poRequest: false,
    },
  },
  deleteSuccess: {
    typeId: MA_DELETE_SUCCESS,
    name: 'Master Agreement delete is success in ITSM',
    nameShort: "MA Delete success",
    allowed: {
      onboarding: false,
      releasing: false,
      updating: false,
      creation: true,
      pendingMessage: false,
      poRequest: false,
    },
  },
  deleteFailed: {
    typeId: MA_DELETE_FAILED,
    name: 'Master Agreement delete is failed in ITSM. Resend is now allowed',
    nameShort: "MA delete failed",
    allowed: {
      onboarding: false,
      releasing: false,
      updating: false,
      creation: true,
      pendingMessage: false,
      poRequest: false,
    },
  },
  maintenance: {
    typeId: MA_MAINTENANCE,
    name: 'The opportunity is under maintenance, master agreement changes are not allowed.',
    nameShort: "MA In Maintenance",
    allowed: {
      onboarding: false,
      releasing: false,
      updating: false,
      creation: false,
      pendingMessage: false,
      poRequest: false,
    },
  },
});

export const masterAgreementLookup = Object.values(masterAgreementStatusValues).reduce(
  (acc, {typeId, name}) => {
    acc[typeId] = name;
    return acc;
  },
  {},
);

export const masterAgreementFullLookup = Object.values(masterAgreementStatusValues).reduce(
  (acc, state) => {
    acc[state.typeId] = state;
    return acc;
  },
  {},
);

export const masterAgreementShortNameLookup = Object.values(masterAgreementStatusValues).reduce(
  (acc, {typeId, nameShort}) => {
    acc[typeId] = nameShort;
    return acc;
  },
  {},
);

const NO_PO = 0;
const PO_PENDING = 1;
const PO_FAIL = 2;
const PO_SUCCESS = 3;
export const deviceIndependentServicePoStatusValues = Object.freeze({
  noDeviceIndServicePo: {
    typeId: NO_PO,
    name: "Device Independent Service PO request not sent yet",
  },
  deviceIndServicePoPending: {
    typeId: PO_PENDING,
    name: "Device Independent Service PO request is pending",
  },
  deviceIndServicePoSuccess: {
    typeId: PO_SUCCESS,
    name: "Device Independent Service PO has been created",
  },
  deviceIndServicePoFail: {
    typeId: PO_FAIL,
    name: "Device Independent Service PO request has failed",
  },
});

export const deviceTypes = Object.freeze({
  unknown: {
    typeId: 0,
    name: "unknown",
    humanReadable: "Unknown",
  },
  asset: {
    typeId: 1,
    name: "asset",
    humanReadable: "Device",
  },
  accessory: {
    typeId: 2,
    name: "accessory",
    humanReadable: "Standalone Accessory",
  },
  software: {
    typeId: 3,
    name: "software",
    humanReadable: "Software Solution",
  },
  independentService: {
    typeId: 4,
    name: "independent service",
    humanReadable: "Device Independent Service",
  },
});
